<template>
  <div>
    <container>
      <div slot="left_box_content">
        <component :is="curLeftComponent" ></component>
      </div>
      <div slot="right_box_content">
        <component :is="curRightComponent" ></component>
      </div>
      <div
        slot="bottom_box_content"
        style="padding:10px 10px;"
      >
        <component
          ref="bottom"
          :is="curBottomComponent"
        ></component>
      </div>
      <div slot="bg_map"></div>
    </container>
  </div>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'

import advertiserStoreModule from '@/store/modules/advertiser'
export default {
  mixins: [sysMixins],
  components: {
    Container,
    Bottom: () => import('./components/Bottom'),
    Right: () => null,
    Left: () => import('./components/Left')
  },
  data () {
    return {
      id: 0
    }
  },
  created () {
    if (!this.$store.hasModule('advertiser')) {
      this.$store.registerModule('advertiser', advertiserStoreModule)
    }
  },
  mounted () {
    this.setShowLeftBlock(true)
    this.setShowRightBlock(false)
    this.setShowMap(false)
    this.setBottomHeight('90%')
    this.setBottomComponent('Bottom')
    this.setLeftComponent('Left')
  }
}
</script>
